module.exports = __webpack_public_path__ + "static/media/clouds.67af8057.svg";